/**
 * SVG icon for community aspect
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function SymbolCommunity({ hoveredAspect }) {
  return (
    <symbol
      className="wheel-icon"
      id="icon-community"
      viewBox="0 0 123.6 121.9"
    >
      <circle
        className={classnames({
          'is-hovered': hoveredAspect === 'tid:63',
          st0: true,
        })}
        cx="61.3"
        cy="23.8"
        r="13.4"
      />
      <circle
        className={classnames({
          'is-hovered': hoveredAspect === 'tid:63',
          st0: true,
        })}
        cx="110.2"
        cy="13.4"
        r="13.4"
      />
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st0: true,
          })}
          d="M26.8,14.2c0-7.4-6-13.4-13.4-13.4c-0.5,0-1,0-1.6,0.1c-2.7,1.9-6.2,5.7-6,12.5c0.2,8,4.9,12.2,8.9,14.1 C21.5,26.9,26.8,21.1,26.8,14.2z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M5.8,13.4c-0.2-6.9,3.3-10.6,6-12.5C5.2,1.6,0,7.3,0,14.2c0,7.4,6,13.4,13.4,13.4c0.4,0,0.9,0,1.3-0.1 C10.8,25.6,6.1,21.5,5.8,13.4z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M53.8,22.9c-0.2-6.9,3.3-10.6,6-12.5c-6.7,0.8-11.8,6.4-11.8,13.3c0,7.4,6,13.4,13.4,13.4c0.4,0,0.9,0,1.3-0.1 C58.7,35.1,54,31,53.8,22.9z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M102.7,12.6c-0.2-6.9,3.3-10.6,6-12.5C102,0.8,96.8,6.5,96.8,13.4c0,7.4,6,13.4,13.4,13.4c0.4,0,0.9,0,1.3-0.1 C107.6,24.8,102.9,20.6,102.7,12.6z"
        />
      </g>
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st2: true,
          })}
          d="M53,64c0.1,2.4,1.1,41.2,4.4,48.8C54.1,105.2,53.1,66.4,53,64z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st0: true,
          })}
          d="M122.5,101.1c-0.2-1.9-7.9-63.9-7.9-63.9s-0.8-3.5-4.3-4.5h0c-7.5,1.3-6,4.2-11.8,8.7 c-5.8,4.5-18.7,3.5-18.7,3.5l0,0c-1.2,0.2-2.4,0.3-3.6,0.3c-6.6-0.1-8.4-1.3-10.1-2.1l0,0c-3.6-1.5-6,3.5-10.9,5.9 C50.3,51.4,40,49.6,40,49.6l0,0c-0.4,0-0.9,0-1.3-0.1c-13.7-1.8-16.6-15.4-23.5-17c-1.9,1.2-4.6,4.3-5,11.9 c-0.6,11.9-2.9,48.8,0,58.3c1.7,5.5,5.5,7.2,8.5,7.7c6.2-2.1,7.6-8.2,7.4-11c-0.3-3.6-4.2-43.1-4.2-43.1S39,72,53,63.9 c0,0,0,0,0,0.1c0.1,2.4,1.1,41.2,4.4,48.8c1.4,3.1,2.5,6.1,8.8,8.6c6.7-1.7,8-7.7,7.7-11.4c-0.3-4.5-4.2-48.7-4.2-48.7 s16.2,2.4,31.1-6.8c0,0,1.6,39,3.4,46.7c1.2,5.3,4.6,8.6,8.4,10.2C122.2,110.3,122.7,102.8,122.5,101.1z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M10.1,102.7c-2.9-9.6-0.6-46.4,0-58.3c0.4-7.6,3.1-10.6,5-11.9c-0.5-0.1-1.1-0.2-1.7-0.1 c-8.3,0.4-8.3,7.9-8.3,7.9L1.5,99.8c0,0-1,10.2,10.7,11.2c2.6,0.2,4.6-0.1,6.4-0.7C15.7,109.9,11.8,108.2,10.1,102.7z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M57.4,112.8c-3.3-7.5-4.3-46.3-4.4-48.8c0-0.1,0-0.1,0-0.1l-3.4,47.9c0,0-0.8,9.1,10.9,10 c2.2,0.2,4.1,0,5.7-0.4C60.5,120.6,60.1,118.9,57.4,112.8z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st3: true,
          })}
          d="M57.4,112.8c2.7,6.1,3.1,7.9,8.8,8.6C59.9,118.8,58.8,115.9,57.4,112.8z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M104.2,101.2c-1.7-7.7-3.4-46.7-3.4-46.7l-4,46.6c0,0-1.4,9.8,11.9,10.4c1.4,0.1,2.7,0,3.8-0.1 C108.8,109.7,105.4,106.5,104.2,101.2z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M55.2,48.9c4.9-2.5,7.3-7.4,10.9-5.9l0,0c-1-0.5-2-1-4.1-1c-5.2,0-13.3,7.8-22.1,7.5l0,0 C40,49.6,50.3,51.4,55.2,48.9z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:63',
            st1: true,
          })}
          d="M98.5,41.3c5.8-4.5,4.3-7.4,11.8-8.7h0c-2.5-0.7-6.3-0.3-12.2,3.4c0,0-8.8,7.3-18.3,8.8l0,0 C79.7,44.8,92.7,45.8,98.5,41.3z"
        />
      </g>
    </symbol>
  );
}

SymbolCommunity.propTypes = {
  hoveredAspect: PropTypes.string,
};

export default SymbolCommunity;



// WEBPACK FOOTER //
// js/src/wheel/symbols/SymbolCommunityBig.js